import React from 'react';

function _typeof(obj) {
  "@babel/helpers - typeof";

  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function _typeof(obj) {
      return typeof obj;
    };
  } else {
    _typeof = function _typeof(obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter);
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(n);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) {
    arr2[i] = arr[i];
  }

  return arr2;
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
/**
 * Helper to account for syntax differences between react helmet
 * and vanilla React when it comes to setting inline JS for script tags.
 */


function createInlineJSScriptTag(_ref) {
  var key = _ref.key,
      inlineJs = _ref.inlineJs,
      useHelmetSyntax = _ref.useHelmetSyntax;

  if (useHelmetSyntax) {
    return (
      /*#__PURE__*/
      React.createElement("script", {
        "data-testid": key,
        key: key,
        type: "text/javascript"
      }, inlineJs)
    );
  } // This is vanilla React way of setting inline JS in script tag.


  return (
    /*#__PURE__*/
    React.createElement("script", {
      "data-testid": key,
      dangerouslySetInnerHTML: {
        __html: inlineJs
      },
      key: key,
      type: "text/javascript"
    })
  );
}
/*
 *    We reuse a lot lof the same breakpoints, and the values are useful in other
 *    locations in the app. We can track them as integer values here.
 */


var DEVICE_LANDSCAPE_DIMENSIONS = {
  mobile: {
    min: 0,
    max: 900
  },
  // Until we are designing for wearables, I think it's okay to leave the min at 0 for mobile
  tablet: {
    min: 900,
    max: 1024
  },
  ipadPro: {
    min: 1366,
    max: 1366
  },
  desktop: {
    min: 1200,
    max: 1799
  },
  desktopLarge: {
    min: 1800,
    max: 10000
  }
};
/**
 * Configuration per environment.
 */

var segmentAnalyticsId = function segmentAnalyticsId(appEnv) {
  switch (appEnv) {
    case 'prod':
      return 'ZBEfAPcb4JXyhBwgim25KtUWUmuunCBK';

    case 'staging':
      return 'hC6hHERRU0b5gWrXcXDeF4RvhFXFoJEh';

    default:
      return '3EdDRLvomym1jHmLhSvPLFh9p4M1gjXq';
  }
};
/**
 * Exception logger.
 * Clients can override default exception logger when calling LoadSegmentAnalytics.
 */


var _exceptionLogger = console.error;
/**
 * Returns the inline Javascript for segment script tag.
 */

var getSegmentInlineJs = function getSegmentInlineJs(appEnv) {
  var segmentId = segmentAnalyticsId(appEnv);
  var segmentInlineJs = "\n    !function(){var analytics=window.analytics=window.analytics||[];\n    if(!analytics.initialize)if(analytics.invoked)window.console&&console.error&&console.error(\"Segment snippet included twice.\");\n    else{analytics.invoked=!0;analytics.methods=[\"trackSubmit\",\"trackClick\",\"trackLink\",\"trackForm\",\"pageview\",\n    \"identify\",\"reset\",\"group\",\"track\",\"ready\",\"alias\",\"debug\",\"page\",\"once\",\"off\",\"on\"];\n    analytics.factory=function(t){return function(){var e=Array.prototype.slice.call(arguments);\n    e.unshift(t);analytics.push(e);return analytics}};for(var t=0;t<analytics.methods.length;t++){var e=analytics.methods[t];\n    analytics[e]=analytics.factory(e)}analytics.load=function(t,e){var n=document.createElement(\"script\");\n    n.type=\"text/javascript\";n.async=!0;n.src=\"https://cdn.segment.com/analytics.js/v1/\"+t+\"/analytics.min.js\";\n    var a=document.getElementsByTagName(\"script\")[0];a.parentNode.insertBefore(n,a);analytics._loadOptions=e};\n    analytics.SNIPPET_VERSION=\"4.1.0\";\n    analytics.load(\"".concat(segmentId, "\");\n    analytics.page();\n    }}();\n  ");
  return segmentInlineJs;
};
/**
 * This component should be placed in the document body right before the closing body tag.
 */


function LoadSegmentAnalytics(_ref) {
  var _ref$appEnv = _ref.appEnv,
      appEnv = _ref$appEnv === void 0 ? 'dev' : _ref$appEnv,
      _ref$exceptionLogger = _ref.exceptionLogger,
      exceptionLogger = _ref$exceptionLogger === void 0 ? console.error : _ref$exceptionLogger,
      _ref$useHelmetSyntax = _ref.useHelmetSyntax,
      useHelmetSyntax = _ref$useHelmetSyntax === void 0 ? false : _ref$useHelmetSyntax;
  _exceptionLogger = exceptionLogger;
  var segmentInlineJs = getSegmentInlineJs(appEnv);
  return createInlineJSScriptTag({
    key: 'segment-js',
    inlineJs: segmentInlineJs,
    useHelmetSyntax: useHelmetSyntax
  });
}
/**
 * Common Segment event tracking.
 * Apps will typically create their own customized events that use these.
 */


var trackPageView = function trackPageView() {
  if (window.analytics && window.analytics.initialize) {
    try {
      window.analytics.page();
    } catch (error) {
      _exceptionLogger(error);
    }
  } else {
    cacheToSegmentQueue('page');
  }
};

var trackEvent = function trackEvent(_ref2) {
  var event = _ref2.event,
      properties = _ref2.properties,
      options = _ref2.options,
      callback = _ref2.callback;
  var userDeviceType = getUserDevice();

  if (_typeof(properties) === 'object') {
    properties.device = userDeviceType;
  }

  if (window.analytics && window.analytics.initialize) {
    try {
      window.analytics.track(event, properties, options, callback);
    } catch (error) {
      _exceptionLogger(error);
    }
  } else {
    cacheToSegmentQueue('track', [event, properties, options, callback]);
  }
};

var trackAuth = function trackAuth(_ref3) {
  var userId = _ref3.userId,
      traits = _ref3.traits,
      options = _ref3.options,
      callback = _ref3.callback;

  if (window.analytics && window.analytics.initialize) {
    try {
      window.analytics.identify(userId, traits, options, callback);
    } catch (error) {
      _exceptionLogger(error);
    }
  } else {
    cacheToSegmentQueue('identify', [userId, traits, options, callback]);
  }
};
/*
*   Cache calls in window.analytics array if Segment
*   has not loaded yet. These will be flushed/called once fully loaded.
*
*   Post-load usage in analytics.min.js:
*
*   while (analyticsq && analyticsq.length > 0) {
*     var args = analyticsq.shift();
*     var method = args.shift();
*
*     if (typeof analytics[method] === 'function') {
*       analytics[method].apply(analytics, args);
*     }
*   }
*/


var cacheToSegmentQueue = function cacheToSegmentQueue(method, args) {
  var segmentQueue = window.analytics || [];
  segmentQueue.push([method].concat(_toConsumableArray(args || [])));
  window.analytics = segmentQueue;
};
/*
*   This method is used to get a good idea of the user
*   device size.
*   It is intended to give device data without having to maintain a
*   true User Agent string parser.
*   We assume that the larger dimension roughly tells us device type
*/


var getUserDevice = function getUserDevice() {
  var mobile = DEVICE_LANDSCAPE_DIMENSIONS.mobile,
      ipadPro = DEVICE_LANDSCAPE_DIMENSIONS.ipadPro,
      desktopLarge = DEVICE_LANDSCAPE_DIMENSIONS.desktopLarge;
  var deviceWidth = document.documentElement.clientWidth;
  var deviceHeight = document.documentElement.clientHeight;
  var largerDimension = Math.max(deviceWidth, deviceHeight);
  var isMobile = largerDimension <= mobile.max; // iPad Pro resolution overlaps desktop, so we set the tablet max higher,
  // and additionally test for orientation functionality

  var hasOrientation = typeof window.orientation !== 'undefined';
  var isTablet = largerDimension <= ipadPro.max && hasOrientation;
  var isDesktop = largerDimension <= desktopLarge.max;

  try {
    switch (true) {
      case isMobile:
        return 'Mobile';

      case isTablet:
        return 'Tablet';

      case isDesktop:
        return 'Desktop';

      default:
        return 'Undefined';
    }
  } catch (e) {
    _exceptionLogger(e);

    return 'Undefined';
  }
};
/**
 * For tracking clicks on external links.
 *
 * This module de-couples clicking on the link from firing the
 * analytics event which allows the click to be dispatched up the
 * chain and handled at the appropriate place.
 *
 * This will delay the page reload until the Segment analytics
 * call has completed and the callback is fired. Note that the
 * segment client controls the logic of how long to wait until
 * the callback is fired.
 *
 * Update: segment will just wait forever causing the page to hang
 * if there is an issue with the analytics request (for example, user
 * has installed an agressive privacy blocker that blocks segment reequests).
 * This we have added a maximum 100ms wait before going ahead and just
 * performing the page navigation.
 */


function ExternalLink(_ref) {
  var children = _ref.children,
      _ref$href = _ref.href,
      href = _ref$href === void 0 ? '' : _ref$href,
      _ref$onClick = _ref.onClick,
      onClick = _ref$onClick === void 0 ? function (_ref2) {
    var href = _ref2.href;
  } : _ref$onClick;

  var handleLinkClick = function handleLinkClick(e) {
    // External links are wrapped with anchor tags so we need to block the
    // default browser navigate to href behavior so we can send analytics
    // events prior to reloading the page.
    e.preventDefault(); // Fire the callback to kick off the dispatch chain.

    onClick({
      href: href
    });
  };

  return (
    /*#__PURE__*/
    React.createElement("a", {
      href: href,
      onClick: handleLinkClick,
      style: {
        textDecoration: 'none'
      }
    }, children)
  );
}

function handleExternalLinkClick(_ref3) {
  var href = _ref3.href,
      event = _ref3.event,
      properties = _ref3.properties,
      _ref3$openInNewTab = _ref3.openInNewTab,
      openInNewTab = _ref3$openInNewTab === void 0 ? false : _ref3$openInNewTab;

  var navigateToLinkDestination = function navigateToLinkDestination() {
    if (openInNewTab) {
      window.open(href, '', 'noopener,noreferrer');
    } else {
      window.location.href = href;
    }
  }; // If the segment request gets blocked by the client (aggressive ad blockers)
  // or just takes too long to complete then we should just go ahead and complete
  // the navigation w/o waiting for a successful analytics event. This is preferred
  // to just having the app hang for the user.


  var timeoutId = setTimeout(navigateToLinkDestination, 100); // Once the segment call has completed, it will invoke this callback.
  // Here we just go ahead and manually refresh the page.

  var callback = function callback() {
    window.clearTimeout(timeoutId);
    navigateToLinkDestination();
  }; // Delegate to segment client to complete the actions.


  trackEvent({
    event: event,
    properties: properties,
    callback: callback
  });
}

export { ExternalLink, LoadSegmentAnalytics, getSegmentInlineJs, handleExternalLinkClick, segmentAnalyticsId, trackAuth, trackEvent, trackPageView };